import type { Listener } from "@rosette/ts/src/business/ListenerStore.js";
import { ListenerStore } from "@rosette/ts/src/business/ListenerStore.js";
import { useRef } from "react";


export function useListenerStore<T extends Listener>(): ListenerStore<T> {
    const storeRef = useRef<ListenerStore<T> | null>(null);
    if (!storeRef.current) {
        storeRef.current = new ListenerStore<T>();
    }
    return storeRef.current;
}
